<template>
  <div class="animated fadeIn">
    <b-card-text class="text-left">
      <p>
        ChatAcuity has been successfully installed in your workspace!  Next, let's figure out which public channels you would like ChatAcuity to start analyzing.
      </p>

      <p>
        Click 'Next' to select channels.
      </p>

    </b-card-text>

    <b-button class="float-right" href="#" variant="primary" @click="nextButtonClick">Next</b-button>
  </div>
</template>


<script>
export default {
  name: 'Step2',
  props: {

  },

  methods: {
    nextButtonClick() {
      this.$store.commit('installStep', 3)
      this.$router.push({ name: 'step2part2' })
    }
  },

  mounted() {
    this.$store.commit('installProgress', 35)
  }
}
</script>